import * as React from "react";
const SvgCollapseClosed = (props) => /* @__PURE__ */ React.createElement("svg", { width: 5, height: 8, viewBox: "0 0 5 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4.61328 4L0.863282 7.89711L0.863282 0.102886L4.61328 4Z", fill: "currentColor" }));
export default SvgCollapseClosed;
